import AttachmentErrorAlerts from './alerts/AttachmentErrorAlerts';
import NetworkErrorAlerts from './alerts/NetworkErrorAlerts';
import RejectedMessageAlert from './alerts/RejectedMessageAlert';
import { jsx as _jsx } from "react/jsx-runtime";
const ChatAreaAlertContainer = ({
  attachmentsError,
  createNewThread,
  dismissAttachmentsError,
  fetchOlderThreadHistory,
  networkError,
  rejectedMessage,
  refreshWithRejectedMessageFilter,
  resubscribe,
  selectAttachmentFile,
  startPubSub,
  thread,
  trackInteraction
}) => {
  if (rejectedMessage) {
    return /*#__PURE__*/_jsx(RejectedMessageAlert, {
      rejectedMessage: rejectedMessage,
      onRefresh: refreshWithRejectedMessageFilter
    });
  }
  if (attachmentsError) {
    return /*#__PURE__*/_jsx(AttachmentErrorAlerts, {
      attachmentsError: attachmentsError,
      dismissAttachmentsError: dismissAttachmentsError,
      selectAttachmentFile: selectAttachmentFile,
      thread: thread,
      trackInteraction: trackInteraction
    });
  }
  if (networkError) {
    return /*#__PURE__*/_jsx(NetworkErrorAlerts, {
      createNewThread: createNewThread,
      fetchOlderThreadHistory: fetchOlderThreadHistory,
      networkError: networkError,
      resubscribe: resubscribe,
      startPubSub: startPubSub
    });
  }
  return null;
};
ChatAreaAlertContainer.displayName = 'ChatAreaAlertContainer';
export default ChatAreaAlertContainer;